import React from 'react'
import "./flexibleGrid.css"
function FlexibleGrid({FirstBox, SecondBox, FirstBoxWidth, SecondBoxWidth}) {
  return (
    <div style={{grid: `auto / calc(${FirstBoxWidth} - 7.5px) calc(${SecondBoxWidth} - 7.5px)`}} className='grid-container'>
        <div width={"40%"} className='item1'>
            {FirstBox}
        </div>
        <div width={"60%"} className='item2'>
            {SecondBox}
        </div>
    </div>
  )
}

export default FlexibleGrid